import type { CustomIconProps } from '../CustomIcon';

export const HomeIcon = ({
  color,
  secondaryColor,
  ternaryColor,
  solid,
  size = 24,
  ...props
}: CustomIconProps) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      fill='none'
      stroke='currentColor'
      strokeWidth={1.5}
      strokeLinecap='round'
      strokeLinejoin='round'
      {...props}>
      <path
        d='m3 9 9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z'
        fill={solid ? color : 'none'}
        stroke={solid ? color : secondaryColor}
      />
      <path d='M9 22V12h6v10' stroke={secondaryColor} />
    </svg>
  );
};
